<template>
  <article class="c_single">
    <div class="c_single_movie">
      <div class="pt-3">
        <survey-content-shokai v-if="isShokai"></survey-content-shokai>
        <survey-content v-else></survey-content>
      </div>
    </div>
  </article>
</template>

<script>
import SurveyContent from "@/components/SurveyContent";
import SurveyContentShokai from "@/components/SurveyContentShokai";

export default {
  components: {
    SurveyContent,
    SurveyContentShokai
  },
  computed: {
    isShokai() {
      return window.location.hostname === "shokai.hygiene.jc3-learning.org";
    }
  }
};
</script>
